import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { IconService } from './core/services/icon.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'eshyft-admin-onboarding';

  constructor() {
    inject(IconService).connectIcons();
  }
}
